<template>
  <aw-spinner />
</template>
<script>
  import { defineNuxtComponent, navigateTo, useRoute } from 'nuxt/app';
  import { fetchKey } from '~~/common/utils/awRunLegacyAsyncData.js';
  import { defineAsyncComponent } from 'vue';

  export default defineNuxtComponent({
    name: 'CetelemStatusBack',
    components: { AwSpinner: defineAsyncComponent(() => import('~~/common/components/Common/AwSpinner')) },
    fetchKey,
    asyncData ({
      $logger,
    }) {
      const route = useRoute();
      try {
        navigateTo(`/cetelem/back?status=${route.params.status}&orderId=${route.params.order_ident}&dossierId=${route.query.dossierId ?? ''}&customerKey=${route.query.customerKey ?? ''}&purchaseAmount=${route.query.purchaseAmount ?? ''}`, { redirectCode: 302 });
        return {};
      } catch (err) {
        $logger.error(err);
      }
      return {};
    },
  });
</script>
